class VeraProductShare extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.button = this.querySelector('button');
    this.label = this.querySelector('[data-share-label]');
    this.status = this.querySelector('.vera-product-share__status');
    this.defaultLabel = this.label?.textContent || '';
    this.button?.addEventListener('click', () => this.share());
  }

  async share() {
    const url = this.dataset.shareUrl || window.location.href.split('#')[0];
    const title = this.dataset.shareTitle || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, text: title, url });
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      const copied = this.dataset.copiedLabel || 'Link copied';
      if (this.label) this.label.textContent = copied;
      if (this.status) this.status.textContent = copied;

      window.setTimeout(() => {
        if (this.label) this.label.textContent = this.defaultLabel;
        if (this.status) this.status.textContent = '';
      }, 2200);
    } catch (_error) {
      window.prompt('', url);
    }
  }
}

if (!customElements.get('product-share')) {
  customElements.define('product-share', VeraProductShare);
}
